export type Callback = (data: any) => void;

export type Unsubscribe = () => void;

export interface Listener {
    name: string;
    callback: Callback;
}


export class EventDispatcher {
    _events: { [name: string] : Callback[]; };

    constructor() {
        this._events = {}
    }

    on(name: string, fn: Callback): Unsubscribe {
        if(!this._events[name]) {
            this._events[name] = [];
        }
        this._events[name].push(fn)

        if(name != "newListener") {
            let newListener: Listener = {
                name: name,
                callback: fn,
            };

            this.dispatch("newListener", newListener)
        }

        return (): void => {
            this.unsubscribe(name, fn)
        }
    }

    dispatch(name: string, data: any) {
        const events: Callback[] = this._events[name]
        if(events) {
            for (let event of events) {
                if(event != null) {
                    event.call(null, data)
                }
            }
        }
    }

    unsubscribe(name: string, fn: Callback) {
        const events: Callback[] = this._events[name]
        if(events) {
            const index = events.indexOf(fn, 0);
            if(index > -1) {
                this._events[name].splice(index, 1);
            }
        }

    }

    unsubscribeAll() {
        for(let name in this._events) {
            delete this._events[name]
        }
    }
}
